<template>
  <Dialog
    titleAlign="left"
    :title="$$t('editor.generate_step_progress')"
    width="680px"
    height="488px"
    :visible="renderData.visible"
    @close="onClose"
    :customClass="`feed-generate-step-dialog feed-generate-step-dialog--${createRenderType}`"
    mobileRenderType="drawerDialog"
  >
    <div class="feed-generate-step-dialog-content">
      <GenerateStep
        :item="props.item"
        :pitem="props.pitem"
        :markdownText="renderData.markdownText"
        :isWriting="false"
      ></GenerateStep>
    </div>
  </Dialog>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
  getCurrentInstance,
} from "vue";
import objectStorage, {
  getObjectStorageFullUrl,
} from "@/lib/objectStorage/objectStorage.js";

import { useRouter, useRoute } from "vue-router";

import Button from "@/components/basic/button/Button.vue";
import GenerateStep from "@/page/create/generateStep/generateStep.vue";
import message from "@/components/functionCallComponent/message.jsx";

import globleConfig, {
  chinaAppName,
  ModuleOpenStateControl,
} from "@/config/config.js";

import { $$language, $$t } from "@/i18n/i18n.js";
import { storeToRefs } from "pinia";
import useUserDataStore from "@/store/userDataStore";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
const userDataStore = useUserDataStore();

const createLayoutStore = useCreateLayoutStore();
const { createRenderType } = storeToRefs(createLayoutStore);
const { userInfo } = storeToRefs(userDataStore);
const Router = useRouter();

const globalProperties =
  getCurrentInstance()?.appContext.config.globalProperties;
const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  pitem: {
    type: Object,
    default: () => ({}),
  },
  item: {
    type: Object,
    default: () => ({}),
  },
});
const emits = defineEmits(["update:visible", "report"]);
const renderData = reactive({
  visible: props.visible,
  markdownText: "",
});

const onClose = () => {
  renderData.visible = false;
};
const doDownloadFile = async (url, filename) => {
  return new Promise((resolve, reject) => {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.responseType = "blob";
    xhr.onload = function (e) {
      if (this.status === 200) {
        var blob = new Blob([this.response], {
          type: this.response?.type || "text/plain",
        });
        const resfile = new File([blob], filename, { type: blob.type });
        resolve(resfile);
      } else {
        reject(this.statusText);
      }
    };
    xhr.send();
  });
};

const getmarkdownText = () => {
  const close = message.loading({
    content: $$t("create.loading"),
  });
  if (props.pitem) {
    doDownloadFile(
      getObjectStorageFullUrl(props.pitem?.thinking_process_url),
      "thinking_process.md"
    )
      .then((linkFile) => {
        const reader = new FileReader();
        reader.readAsText(linkFile, "utf-8");
        reader.onload = function (e) {
          renderData.markdownText = e.target.result ?? "";
          globalProperties.logCustomEvent("creative_process_show", {
            tab_stare: "create_generated",
            content_id: props.item?.song_id,
          });
        };
        reader.onerror = function (e) {
          renderData.visible = false;
          message.error({
            position: "top",
            content: $$t("common.load_failure"),
          });
        };
        close?.clear();
      })
      .catch((e) => {
        reject(e);
        close?.clear();
        message.error({
          position: "top",
          content: $$t("common.load_failure"),
        });
        renderData.visible = false;
      });
  }
};

watch(
  () => props.visible,
  (val) => {
    renderData.visible = props.visible;
  }
);

watch(
  () => renderData.visible,
  (val) => {
    emits("update:visible", val);
  }
);

onMounted(() => {
  getmarkdownText();
});
</script>
<style lang="scss">
.feed-generate-step-dialog {
  padding: 0 0 0 16px;
  .dialog-box {
    max-height: 80% !important;
  }
  .content-top-margin {
    height: 20px !important;
  }
  .dialog-header {
    padding: 0 60px 0 40px;
  }
  .feed-generate-step-dialog-content {
    padding: 0 40px 40px 40px;
    height: 100%;
    overflow-y: auto;
    .generate-step-input-box {
      display: none;
    }
  }
  .markdown-viewer {
    width: 100%;
    font-family: HarmonyOS Sans SC;
    font-size: 14px;
    font-weight: normal;
    line-height: 24px;
    color: #ffffff;
    strong {
      font-weight: 600;
      font-size: 16px;
    }
  }
  .generate-step-container {
    padding: 10px 16px;
    border: none;
    background: rgba(255, 255, 255, 0.1);
    .generate-step-result-box {
      margin: 0;
    }
    .generate-step-avatar {
      display: none;
    }
  }
  &.feed-generate-step-dialog--mobile {
    .dialog-header {
      padding: 0 16px;
    }
    .feed-generate-step-dialog-content {
      padding: 0 16px 16px 16px;
      height: 100%;
    }
  }
}
</style>
